import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types'; // ES6

import { DatePicker } from 'antd';
import { convertirTextAMomentUTC, esDataValidaSelectorObservacions, MASCARA_DDMMYYYY, MASCARA_YYYYMMDD } from '../../commons/gestioDates';
import { seleccionarDataConsultaMapa } from '../../actions/index';

const estilsEstats = {
    1: {backgroundColor: '#e74c3c', color: '#f5f5f5'}, // cap inf   ormada - red
    2: {backgroundColor: '#FFC312'}, // alguna informada - yellow
    3: {backgroundColor: '#27ae60', color: '#fff'} // totes les obligatòries informades - green
};

class ObservacioSelectorDataPeriode extends Component {

    constructor(props) {
        super(props);

        this.renderitzaDia = this.renderitzaDia.bind(this);
        this.onChange = this.onChange.bind(this);
        this.esDiaDeshabilitat = this.esDiaDeshabilitat.bind(this);
    }

    /**
     * Renderitza una casella del calendari del datetimepicker referent a un dia.
     *
     * @param props
     * @param dataActual {Moment}
     * @returns
     */
    renderitzaDia(dataActual) {
        const estatsObservacions = this.props.estats;
        const dataActualText = dataActual.format(MASCARA_YYYYMMDD);

        //Es cerca l'estat de la observacio associada a la data seleccionada al datePicker
        const estatObservacioDataActual = estatsObservacions.find(estatObservacio => estatObservacio.data === dataActualText);

        //Si es disposa de l'estat de la observació pel dia seleccionat, s'associa un estil
        const estilDia = estatObservacioDataActual ? estilsEstats[estatObservacioDataActual.estat] : null;

        return (
            <div className="ant-calendar-date" style={estilDia}>
                {dataActual.date()}
            </div>
        );
    }

    esDiaDeshabilitat(dataCalendari) {
        const dataActual = convertirTextAMomentUTC(this.props.dataActualText);

        return esDataValidaSelectorObservacions(dataCalendari, dataActual, 'days');
    }

    onChange(dataSeleccionada) {
        const dataSeleccionadaActualmentText = this.props.dataSeleccionadaText;
        const dataSeleccionadaActualment = convertirTextAMomentUTC(dataSeleccionadaActualmentText, MASCARA_YYYYMMDD);

        if (dataSeleccionada && !dataSeleccionada.isSame(dataSeleccionadaActualment, 'days')) {
            this.props.seleccionarDataConsultaMapa(dataSeleccionada);
        }

        if (dataSeleccionada === null) { // no es pot deseleccionar al data
            this.datepicker.picker.setState({value: dataSeleccionadaActualment});
        }
    }

    render() {
        const { dataSeleccionadaText } = this.props;

        if (!dataSeleccionadaText) {
            return <div></div>;
        }

        const dataSeleccionada = convertirTextAMomentUTC(dataSeleccionadaText, MASCARA_YYYYMMDD);

        return (
            <DatePicker
                ref={ (datepicker) => { this.datepicker = datepicker; }}
                dateRender={ this.renderitzaDia }
                defaultValue={ dataSeleccionada }
                format={ MASCARA_DDMMYYYY }
                onChange={ this.onChange }
                disabledDate={ this.esDiaDeshabilitat || this.esDiaAnteriorDataLimit }
                allowClear={ false }
            />
        );
    }
}

ObservacioSelectorDataPeriode.propTypes = {
    estats: PropTypes.array,
    dataSeleccionadaText: PropTypes.string,
    dataActualText: PropTypes.string,
    seleccionarDataConsultaMapa: PropTypes.func
};

const mapStateToProps = (state) => ({
    estats: state.observacio.estats,
    dataSeleccionadaText: state.observacio.dataSeleccionada,
    dataActualText: state.dataActual
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        seleccionarDataConsultaMapa
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ObservacioSelectorDataPeriode);



// WEBPACK FOOTER //
// ./src/components/observacio/observacioSelectorDataPeriode.js